import React, { useEffect, useState, useRef } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";

interface Props {
    value?: string;
    setValue: (val: string) => void;
    readOnly?: boolean;
    disabled?: boolean;
    inPopup?: boolean;
}

export default function DateField(props: Props) {
    const [valDate, setValDate] = useState(props.value ? moment(props.value, 'YYYY-MM-DD').toDate() : undefined);
    const [isOpen, setIsOpen] = useState(false);
    const datePickerRef = useRef<DatePicker>(null);

    useEffect(() => {
        setValDate(props.value ? moment(props.value, 'YYYY-MM-DD').toDate() : undefined);
    }, [props.value]);

    useEffect(() => {
        props.setValue(valDate ? moment(valDate).format("YYYY-MM-DD") : '');
    }, [valDate]);

    const handleChange = (date: Date) => {
        setValDate(date);
        setIsOpen(false);
    };

    const handleClickOutside = () => {
        setIsOpen(false);
    };

    const handleInputClick = () => {
        setIsOpen(true);
    };

    return (
        <div onClick={e => props.inPopup && e.stopPropagation()}>
            <DatePicker
                className="form-control"
                dateFormat="yyyy-MM-dd"
                readOnly={props.readOnly}
                selected={valDate}
                onChange={handleChange}
                disabled={props.disabled}
                calendarStartDay={1}
                portalId={props.inPopup ? undefined : "root-portal"}
                popperProps={{
                    strategy: props.inPopup ? "fixed" : undefined,
                }}
                popperClassName={props.inPopup ? "tw3-z-[9999]" : ""}
                ref={datePickerRef}
                open={isOpen}
                onClickOutside={handleClickOutside}
                onInputClick={handleInputClick}
                shouldCloseOnSelect={true}
            />
        </div>
    );
}